import apiClient from "src/utils/apiClient";
import { createToast } from "src/store/toastsSlice";
import store from "src/store/store";
import { TOAST_TIMEOUT } from "src/config/Toast";

class ModelService {
  async getSiteDetails(siteCode: string) {
    return await apiClient.get(`/site/site_details/${siteCode}`);
  }

  async getSiteDetailsV2(siteCode: string) {
    return await apiClient.get(`/site/site_details_v2/${siteCode}`);
  }
}

export default new ModelService();
